import { Menu, Transition } from "@headlessui/react";
import React from "react";
import { Fragment, useEffect, useRef, useState } from "react";
import { FaAngleDown, FaCheck, FaList, FaUserAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import { useDeptHook } from "../../../hooks/useDeptHook";
import usePositionHook from "../../../hooks/usePositionHook";

export default (props: any) => {
  var { pickedRole, setPickedRole } = props.hook;

  const { AllOrgDepts } = useDeptHook();
  const { allorgPositions } = usePositionHook();

  useEffect(() => {
    setPickedRole(props.defaultvalue);
    console.log(props.defaultvalue);
  }, []);

  return (
    <>
      <Menu
        as="div"
        className={`relative my-2 ${props.maxwidth ? "min-w-[250px]" : ""}   ${
          props.fullwidth ? "min-w-full" : ""
        }`}
      >
        <div>
          {!props.notitle && <p className="text-xs mb-2 "> {props.title}</p>}
          <Menu.Button className="  px-4 py-2  flex text-sm bg-white shadow border rounded-[8px] w-full       ">
            <div className="flex    w-full gap-4">
              <div className=" flex justify-between w-full max-h-[200px] overflow-y-scroll p-1">
                <div className="text-xs font-light">
                  {props.selectedSub.length > 0 ? (
                    props.selectedSub.map((d: any) => (
                      <div className="  bg-customGray w-full p-3 m-2 cursor-pointer flex-col flex justify-start items-start  ">
                        <p className="text-sm text-blackfont-bold truncate">
                          {`${d.firstName} ${d.lastName} `}
                        </p>
                        <p className=" text-xs font-light">
                          Position:
                          {
                            allorgPositions.filter(
                              (m: any) => m.id == d.positionID
                            )[0]?.positionTitle
                          }{" "}
                          Department:
                          {
                            AllOrgDepts.filter((k) => k.id == d.deptID)[0]
                              ?.deptName
                          }
                        </p>
                      </div>
                    ))
                  ) : (
                    <p>Select {props.title}</p>
                  )}
                </div>{" "}
                <FaAngleDown color="#777777" />
              </div>

              <div className="flex items-center"></div>
            </div>
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="origin-top-left z-10 absolute left-0 mt-2 rounded-sm shadow-md p-1 bg-white  max-h-[200px]  w-full overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none">
            {props.list.map((item: any) => (
              <Menu.Item>
                {({ active }) => (
                  <div
                  onClick={() => {


                    if (props.selectedSub.includes(item)) {
                      props.setselectedSub((prev: any) =>
                        props.selectedSub.filter((g: any) => g != item)
                      );
                    }
                     else {

                      if(props.ismanager){
                        props.setselectedSub([item]  );
                      }
                   else{
                    props.setselectedSub((prev: any) =>
                      prev.concat(item)
                    );
                   }
                    }
                  }
                
                }
                  className="flex hover:bg-customGray w-full p-3 justify-center items-center">
                    <div
                      className="  m-2 cursor-pointer w-full "
                     
                    >
                      <p className="text-sm text-blackfont-bold truncate">
                        {`${item.firstName} ${item.lastName} `}
                      </p>
                      <p className=" text-xs font-light">
                        Position:
                        {
                          allorgPositions.filter(
                            (m: any) => m.id == item.positionID
                          )[0]?.positionTitle
                        }{" "}
                        Department:
                        {
                          AllOrgDepts.filter((k) => k.id == item.deptID)[0]
                            ?.deptName
                        }
                      </p>
                    </div>

                    {props.selectedSub.includes(item) && (
                      <FaCheck className="text-primary" />
                    )}
                  </div>
                )}
              </Menu.Item>
            ))}
          </Menu.Items>
        </Transition>
      </Menu>
    </>
  );
};
